import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b46e430"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invest-detail" }
const _hoisted_2 = { class: "invest-detail-content" }
const _hoisted_3 = { class: "invest-detail-box" }
const _hoisted_4 = { class: "invest-detail-box-tp" }
const _hoisted_5 = { class: "invest-detail-box-title" }
const _hoisted_6 = {
  key: 0,
  class: "invest-detail-box-sub"
}
const _hoisted_7 = { class: "invest-detail-box-time" }
const _hoisted_8 = {
  key: 1,
  class: "invest-detail-box-address"
}
const _hoisted_9 = { class: "invest-detail-box-status" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 关注商家 ")
const _hoisted_11 = { class: "invest-detail-box-wz" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode("会员报名")
const _hoisted_14 = { class: "invest-detail-rt" }
const _hoisted_15 = { class: "invest-detail-hd" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invest-detail-title" }, "发布者", -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "invest-detail-project" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invest-detail-title" }, "更多项目", -1))
const _hoisted_26 = { class: "invest-detail-ad" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "invest-detail-ad-line"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invest-detail-ad-bt" }, null, -1))
const _hoisted_30 = { class: "invest-detail-ad-label" }

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import { Plus, ZoomIn, Download, Delete } from "@element-plus/icons-vue";
import type { UploadFile } from "element-plus/es/components/upload/src/upload.type";
import { useRouter } from "vue-router";
import Bottom from "../components/bottom.vue";
import { OfficeBuilding, Clock, Location } from "@element-plus/icons-vue";
import Happy from "../components/happy.vue";
import { onBeforeRouteUpdate } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
var id = router.currentRoute.value.params.id;
const bindData = reactive({
  activityId: id,
  isHasApply:'N',
  activity: {},
  company: {},
  projectList: [],
  activityList: [],
  isLogin: ustore.state.loginMember == undefined ? false : true,
});


if (ustore.state.loginMember == undefined) {
  store.dispatch("getMyInfo").then(
    (data) => {
      //成功
      bindData.isLogin = ustore.state.loginMember == undefined ? false : true
    },
    (error) => {
      console.log("获取当前登录会员信息错误");
    }
  );
}

const activity = (id: any) => {
  if (typeof id == "string") {
    store.dispatch("frontInvestModule/getActivity", { id: id }).then(
      (data) => {
        //成功
        bindData.activity = data.result;
        getCompany(data.result.companyCode);
      },
      (error) => {
        console.log(error.msg);
      }
    );
  }
};
activity(id);
const handleToMemberTabel = () => {
  router.push("/frontDesk/fdInvestList/fdInvestTabel/" + id);
};

const getCompany = (companyCode: string) => {
  store
    .dispatch("frontIndexModule/getCompany", { companyCode: companyCode })
    .then(
      (data) => {
        //成功
        bindData.company = data.result;
      },
      (error) => {
        ElMessageBox.alert(error.msg, "系统消息", {
          confirmButtonText: "关闭",
          callback: (action: Action) => { },
        });
      }
    );

  store
    .dispatch("frontInvestModule/pageProjectList", {
      curPage: 1,
      pageSize: 10,
      filtrate: {
        companyCode: companyCode,
      },
    })
    .then(
      (data) => {
        //成功
        bindData.projectList = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );

  store
    .dispatch("frontInvestModule/pageActivityList", {
      curPage: 1,
      pageSize: 10,
      filtrate: {
        type: 1,
        companyCode: companyCode,
      },
    })
    .then(
      (data) => {
        //成功
        bindData.activityList = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};


const checkIsApply = (id: any) => {
    store.dispatch("frontInvestModule/checkIsApply", { activityId: id }).then(
      (data) => {
        //成功
        bindData.isHasApply = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

checkIsApply(id);

const handleToDetail = (item: any) => {
  router.push("/frontDesk/fdInvestList/fdInvestDetail/" + item.id);
};

const goToHome = () => {
  router.push("/company/companyIndex/" + bindData.company.code);
}

const handleToRssActivity = (e: Event, companyId: string) => {
  e.stopPropagation();
  if (bindData.isLogin) {
    store
      .dispatch("frontBbsModule/saveRssActivity", {
        rssCompanyId: companyId,
      })
      .then(
        (data) => {
          console.log(data);
          //成功
          ElMessage.success('订阅成功.');
        },
        (error) => {
          console.log(error.msg);
        }
      );
  }
  else {
    ElMessageBox.alert("请先登录...", '系统消息', {
      confirmButtonText: '确定',
      callback: (action: Action) => {
        if (action == "confirm") {
          router.push('/frontDesk/login')
        }
      },
    });
  }
}
onBeforeRouteUpdate((to) => {
  var id = to.params.id;
  activity(id);
});

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_container, { class: "invest-detail-main" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_carousel, { class: "invest-detail-carousel" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).activity.imageList, (image) => {
                    return (_openBlock(), _createBlock(_component_el_carousel_item, {
                      key: image.id,
                      style: {"display":"flex","justify-content":"center"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_image, {
                          class: "invest-detail-carousel-banner",
                          src: image.thumbnailUrl
                        }, null, 8, ["src"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(bindData).activity.name), 1),
                (_unref(tool).isNotNull(_unref(bindData).activity.projectName))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(OfficeBuilding))
                        ]),
                        _: 1
                      }),
                      _createTextVNode(_toDisplayString(_unref(bindData).activity.projectName), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Clock))
                    ]),
                    _: 1
                  }),
                  _createTextVNode(_toDisplayString(_unref(bindData).activity.pushTime), 1)
                ]),
                (_unref(tool).isNotNull(_unref(bindData).activity.province))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Location))
                        ]),
                        _: 1
                      }),
                      _createTextVNode(_toDisplayString(_unref(bindData).activity.province) + "，" + _toDisplayString(_unref(bindData).activity.city) + "，" + _toDisplayString(_unref(bindData).activity.area) + "，" + _toDisplayString(_unref(bindData).activity.address), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_container, {
                    class: "company-index-header-collect",
                    onClick: _cache[0] || (_cache[0] = (e) => handleToRssActivity(e, _unref(bindData).activity.companyId))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_image, {
                        fit: "fill",
                        class: "company-index-header-collect-icon",
                        src: require('@/assets/fd/company/u1493.png'),
                        style: {"width":"25px","height":"25px","padding-top":"10px"}
                      }, null, 8, ["src"]),
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  innerHTML: _unref(bindData).activity.request
                }, null, 8, _hoisted_12)
              ]),
              _createVNode(_component_el_container, { class: "invest-detail-box-btn" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElButton), {
                    type: "primary",
                    size: "large",
                    onClick: handleToMemberTabel
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createVNode(Happy, {
              class: "invest-detail-happy",
              activityId: _unref(bindData).activityId
            }, null, 8, ["activityId"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_el_container, { class: "invest-detail-logo" }, {
                default: _withCtx(() => [
                  (_unref(tool).isNotNull(_unref(bindData).company.logoFullPath))
                    ? (_openBlock(), _createBlock(_component_el_image, {
                        key: 0,
                        class: "invest-detail-banner",
                        mode: "widthfix",
                        fit: "scale-down",
                        src: _unref(bindData).company.logoFullPath
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true),
                  (_unref(tool).isNull(_unref(bindData).company.logoFullPath))
                    ? (_openBlock(), _createBlock(_component_el_image, {
                        key: 1,
                        class: "invest-detail-banner",
                        mode: "widthfix",
                        fit: "scale-down",
                        src: require('@/assets/no_pict.png'),
                        lazy: true
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createElementVNode("div", {
                class: "invest-detail-name blue",
                onClick: goToHome
              }, [
                _createVNode(_component_el_image, {
                  class: "aside-top-title-icon",
                  src: require('@/assets/icon_home.png')
                }, null, 8, ["src"]),
                _createTextVNode(_toDisplayString(_unref(bindData).company.name), 1)
              ]),
              _createVNode(_component_el_form, {
                class: "invest-detail-form",
                "label-width": "70px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "invest-detail-form-line",
                    label: "联系人:"
                  }, {
                    default: _withCtx(() => [
                      (_unref(bindData).isHasApply == 'Y')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(bindData).company.contact), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_18, "报名后显示"))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    class: "invest-detail-form-line",
                    label: "电话:"
                  }, {
                    default: _withCtx(() => [
                      (_unref(bindData).isHasApply == 'Y')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(bindData).company.tel), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_20, "报名后显示"))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    class: "invest-detail-form-line",
                    label: "微信号:"
                  }, {
                    default: _withCtx(() => [
                      (_unref(bindData).isHasApply == 'Y')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(bindData).company.weixin), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_22, "报名后显示"))
                    ]),
                    _: 1
                  }),
                  (_unref(bindData).isHasApply == 'Y')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (_unref(tool).isNotNull(_unref(bindData).company.weixinQrcodeFullPath))
                          ? (_openBlock(), _createBlock(_component_el_image, {
                              key: 0,
                              class: "invest-detail-banner",
                              mode: "widthfix",
                              fit: "scale-down",
                              src: _unref(bindData).company.weixinQrcodeFullPath
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode(_component_el_container, { class: "invest-detail-project-box" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).projectList, (project) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: project.id
                    }, _toDisplayString(project.name), 1))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).activityList, (activity) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "invest-detail-ad-box",
                  key: activity.id,
                  onClick: () => handleToDetail(activity)
                }, [
                  (activity.id != _unref(bindData).activity.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createVNode(_component_el_carousel, {
                          class: "invest-detail-ad",
                          height: "200px"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.imageList, (image) => {
                              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                key: image.id,
                                style: {"display":"flex","justify-content":"center"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_image, {
                                    class: "invest-detail-ad-banner",
                                    mode: "widthfix",
                                    src: image.thumbnailUrl
                                  }, null, 8, ["src"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024),
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, _toDisplayString(activity.name), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_27))
              }), 128))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(Bottom)
  ]))
}
}

})